<svg viewBox="0 0 500 500" preserveAspectRatio="xMidYMid meet" style="min-width: 100%; min-height: 100%;object-fit: cover;border: none;">
    <defs>
        <pattern
                id="diagonalHatch"
                patternUnits="userSpaceOnUse" 
                width="4" 
                height="8" 
                patternTransform="rotate(-45 2 2)"
            >
                <path d="M -1,2 l 6,0" stroke="#616161" stroke-width=".5"/>
        </pattern>
    </defs>
    <rect
        x="1"
        y="1" 
        width="100%" 
        height="100%"
        stroke= "#000000" 
        stroke-width="0" 
        fill=  "url(#diagonalHatch)" 
    />
</svg>